export default {
  SCREEN: {
    title: 'What would you like to discuss today?'
  },
  UPDATE_ERROR: {
    severity: 'error' as 'error',
    title: 'Uh oh!',
    subtitle: 'There was an issue updating your appointment details.'
  },
  GET_ERROR: {
    title: 'There was an issue fetching your visit form'
  }
};
